import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";

import { activePRODADeviceApiRoute } from "../../apiRoutes";

import Button from "../../components/button";
import ICInput from "../../components/form/input";
import Loader from "../../components/loader";

import { resetPRODAInfo } from "../../reduxStore/actions/auth";

const ActivatePRODADevice = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [callStatus, setCallStatus] = useState(null);

  const callActivationAPI = values => {
    if (!values.activationCode) return;

    var formData = new FormData();
    formData.append("activateCode", values.activationCode);
    setApiCallParams({
      reqType: "POST",
      reqUrl: activePRODADeviceApiRoute,
      dataObj: formData,
      successCallback: res => {
        props.resetPRODAInfo(res.data.data);
        setCallStatus("Success");
        setIsProcessing(false);
      },
      failureCallback: err => {
        //setCallStatus(err.message);
        setIsProcessing(false);
      }
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      activationCode: ""
    },
    validationSchema: Yup.object({
      activationCode: Yup.string().required("Please enter Activation Code")
    }),
    onSubmit: values => {
      setIsProcessing(true);
      callActivationAPI(values);
    }
  });

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
          <div className="form-row mt-5 ml-2 pl-5">
            <p className="pl-5 ml-5">
              Please enter the PRODA Device Activation Code:
            </p>
            <ICInput
              name="activationCode"
              className="ml-2 search-columns-input"
              type="text"
              autoComplete="off"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.activationCode}
              error={
                formik.touched.activationCode && formik.errors.activationCode
                  ? true
                  : false
              }
              helperText={
                formik.touched.activationCode && formik.errors.activationCode
                  ? formik.errors.activationCode
                  : ""
              }
            />
          </div>
          {callStatus === "Success" ? (
            <p
              className="text-success text-center"
              style={{ fontSize: "12px" }}
            >
              Updating success
            </p>
          ) : (
            <p className="text-danger text-center" style={{ fontSize: "12px" }}>
              {callStatus}
            </p>
          )}
          <br />
          <div className="mb-0 d-flex flex-row justify-content-center">
            {callStatus === "Success" ? (
              <Button
                title="OKAY"
                type="button"
                clickEvent={() => {
                  formik.resetForm();
                  props.cancelEvent();
                }}
              />
            ) : (
              <span>
                <Button
                  className="insta-button-primary ml-4 mr-4 mb-4 button-inline"
                  title="Submit"
                  type="submit"
                />
                <Button
                  className="insta-button-primary ml-4 mr-4 mb-4 button-inline"
                  title="Cancel"
                  type="button"
                  clickEvent={() => {
                    formik.resetForm();
                    props.cancelEvent();
                  }}
                />
              </span>
            )}
          </div>
          {/* API Call */}
          <MakeAPICall apiParam={apiCallParams} />
        </form>
      </div>
    </Fragment>
  );
};

const mapDispatchToProps = dispatch => ({
  resetPRODAInfo: data => dispatch(resetPRODAInfo(data))
});

export default connect(null, mapDispatchToProps)(ActivatePRODADevice);

ActivatePRODADevice.propTypes = {
  cancelEvent: PropTypes.func.isRequired
};
